"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.condicionImpositiva = exports.initialFormState = void 0;
;
/**
 * Initial state of personal data.
 * @name initialFormState
*/
exports.initialFormState = {
    tipoPersona: "FISICA",
    condicionImpositiva: "CONSUMIDOR_FINAL",
    dni: "",
    cuit: "",
    socialReason: "",
    sex: "",
    name: "",
    lastname: "",
    email: "",
    areaCode: "",
    phone: "",
    localityID: "",
    street: "",
    streetNumber: "",
    floor: "",
    number: "",
    zipCode: "",
    stateID: "",
    locality: "",
    nationality: "",
    birthday: "",
    takerActivity: "",
};
/**
 * List of impositive conditions.
 * @name condicionImpositiva
*/
const condicionImpositiva = (tipoPersona) => {
    if (tipoPersona === "JURIDICA") {
        return [
            { name: "Exento", value: "EXCENTO" },
            { name: "Responsable Inscripto", value: "RESPONSABLE_INSCRIPTO" },
        ];
    }
    else {
        return [
            { name: "Consumidor final", value: "CONSUMIDOR_FINAL" },
            { name: "Exento", value: "EXCENTO" },
            { name: "Monotributista", value: "MONOTRIBUTISTA" },
            { name: "Responsable Inscripto", value: "RESPONSABLE_INSCRIPTO" },
        ];
    }
};
exports.condicionImpositiva = condicionImpositiva;
//# sourceMappingURL=utils.js.map